import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { documentVerificationTypes, HTTP_STATUSES } from "../../../../utils/consts";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import Notification from "../../../elements/notification/Notification";
import MaterialPagination from "../../../styles/materialPagination";
import DocumentFilter from "./DocumentFilter";
import DocumentInvoice from "./DocumentInvoice";
import DocumentList from "./DocumentList";

const DocumentContainer = () => {
  const [documents, setDocuments] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", documentVerificationTypes.SUM_SUB, false, true),
    "createdAt[gte]": checkFilterItem(history, "createdAt[gte]", null, true),
    "createdAt[lte]": checkFilterItem(history, "createdAt[lte]", null, true),
    "attributes.value": checkFilterItem(history, "attributes.value", null),
    "status.value": checkFilterItem(history, "status.value", null),
    "schema.name": checkFilterItem(history, "schema.name", null),
    "connection.project.name": checkFilterItem(history, "connection.project.name", null)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  // TODO Add pusher
  const updateTransaction = (message) => {
    const data = JSON.parse(message.data);
    const index = documents.findIndex(item => item.id === data.id);
    if (index >= 0) {
      documents[index].status = data.status;
      let newArr = [];
      setDocuments([
        ...documents,
        ...newArr
      ]);
    }
  };

  const fetchDocument = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/documents" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setDocuments(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  useEffect(() => {
    fetchDocument();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <div className="document-head">
        <DocumentFilter
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <ItemsPerPageSelect
          itemsPerPage={filterData.itemsPerPage}
          setItemsPerPage={(data) => setFilterData({
            ...filterData,
            "itemsPerPage": data,
            page: 1
          })}
        />
        <DocumentInvoice fetchDocument={fetchDocument} />
      </div>
      <DocumentList document={documents} />
      {totalPageCount &&
        <MaterialPagination
          count={totalPageCount}
          shape="rounded"
          page={filterData.page}
          onChange={(event, page) => onChangePage(event, page)}
        />}
    </>
  );
};

export default DocumentContainer;